// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import './styles/tremor-light.css';

// ponytail: silence every console.log app-wide, except tagged debug lines;
// delete this block to restore full logging
{
  const _log = console.log.bind(console);
  console.log = (...args) => {
    if (typeof args[0] === 'string' && args[0].startsWith('[FusionSync]')) _log(...args);
  };
}

// ponytail: patch ResizeObserver to debounce via rAF — prevents loop error at source
(function() {
  const OrigRO = window.ResizeObserver;
  if (!OrigRO) return;
  window.ResizeObserver = function(callback) {
    const instance = new OrigRO((entries, obs) => {
      requestAnimationFrame(() => callback(entries, obs));
    });
    return instance;
  };
  window.ResizeObserver.prototype = OrigRO.prototype;
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);